import React from 'react';
import { Form } from 'react-bootstrap';

const FormCad = ({ handleSubmit, schema, tipoMeioAnalise, setTipoMeioAnalise, errors }) => {
  const handleChange = event => {
    const { name, value, files } = event.target;
    setTipoMeioAnalise({
      ...tipoMeioAnalise,
      [name]: files ? files[0] : value,
    });
  };

  return (
    <Form id="form_tipoMeioAnalise" onSubmit={handleSubmit} schema={schema}>
      <div className="form-group">
        <label htmlFor="nome"> Nome </label>
        <Form.Control
          id="nome"
          isInvalid={!!errors.nome}
          name="nome"
          onChange={handleChange}
          placeholder="Nome"
          type="text"
          value={tipoMeioAnalise.nome || ''}
        />
        <Form.Control.Feedback type="invalid">
          {errors.nome}
        </Form.Control.Feedback>
      </div>
      <div className="form-group">
        <label htmlFor="descricao"> Descrição </label>
        <Form.Control
          id="descricao"
          isInvalid={!!errors.descricao}
          name="descricao"
          onChange={handleChange}
          placeholder="Descricao"
          type="text"
          value={tipoMeioAnalise.descricao || ''}
        />
        <Form.Control.Feedback type="invalid">
          {errors.descricao}
        </Form.Control.Feedback>
      </div>
    </Form>
  );
};

export default FormCad;
